module.exports = __webpack_public_path__ + "static/sign.9f7da4b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sign.jpg
// module id = 500
// module chunks = 35783957827783